export default "__VITE_ASSET__Cli5$wFs__"